import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

const initialState = {
  loading: false,
  customerData: [],
  error: "",
  success: false,
  status: "",
};

const fetchCustomer = createAsyncThunk("fetch/customer", async ({ urls }) => {
  try {
    const result = await Promise.all(urls.map((url) => axios.get(url)));   
    return result
    .filter((val) => !val?.data?.errors) // Filter out entries with errors
    .filter((val) => val?.data?.statusLabel !== "Deletion_Pending") // Exclude entries with "Deletion_Pending" status
    .map((val) => val?.data);
  } catch (err) {
    console.log(err);
  }
});

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    reset: (state, payload) => {
      state.loading = false;
      state.success = false;
      state.error = "";
      state.customerData = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCustomer.fulfilled, (state, action) => {
      state.loading = false;      
      state.customerData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchCustomer.rejected, (state, action) => {
      state.loading = false;
      state.customerData = [];
      state.error = action.error.message;
    });
  },
});

export default customerSlice.reducer;
export const { reset } = customerSlice.actions;
export { fetchCustomer };
